"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _dateFns = require("date-fns");
var _types = require("../utils/types");
var _constants = require("../utils/constants");
var _NewTabBar = _interopRequireDefault(require("./TabBar/NewTabBar"));
var _helpers = require("../utils/helpers");
var _hooks = require("../utils/hooks");
var _ConversationList = _interopRequireDefault(require("./ConversationList/ConversationList"));
var _ConversationView = _interopRequireDefault(require("./ConversationView/ConversationView"));
var _package = require("../../package.json");
require("./UnifiedInbox.scss");
var _excluded = ["titleTabBar", "conversations", "draftMessages", "selected", "setTheUrlOfAttachments", "setNumFiles", "onSelect", "lang", "agent", "disabledActions", "getUploadState"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
console.log('Package data\nName:', _package.name, '\nVersion:', _package.version);
var reduceConversations = function reduceConversations(acc, conv, val) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, conv.campType, _objectSpread(_objectSpread({}, acc[conv.campType]), {}, _defineProperty({}, conv.id, val))));
};
var UnifiedInbox = function UnifiedInbox(_ref) {
  var titleTabBar = _ref.titleTabBar,
    conversations = _ref.conversations,
    draftMessages = _ref.draftMessages,
    selected = _ref.selected,
    setTheUrlOfAttachments = _ref.setTheUrlOfAttachments,
    setNumFiles = _ref.setNumFiles,
    onSelect = _ref.onSelect,
    lang = _ref.lang,
    agent = _ref.agent,
    disabledActions = _ref.disabledActions,
    getUploadState = _ref.getUploadState,
    actions = _objectWithoutProperties(_ref, _excluded);
  var tabs = (0, _react.useMemo)(function () {
    return titleTabBar.map(function (t) {
      return t.toUpperCase();
    });
  }, [titleTabBar]);
  var initialCounts = (0, _react.useMemo)(function () {
    return tabs.reduce(function (a, v) {
      return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, v, 0));
    }, {});
  }, [tabs]);
  var _useState = (0, _react.useState)(_constants.TABS.HOME),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var _useState3 = (0, _react.useState)(initialCounts),
    _useState4 = _slicedToArray(_useState3, 2),
    unreadCounts = _useState4[0],
    setUnreadCounts = _useState4[1];
  var _useState5 = (0, _react.useState)(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    activeMessage = _useState6[0],
    setActiveMessage = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    openMessages = _useState8[0],
    setOpenMessages = _useState8[1];
  var prevSelected = (0, _react.useRef)(null);
  var endConversations = (0, _react.useRef)([]);
  var _useState9 = (0, _react.useState)(),
    _useState10 = _slicedToArray(_useState9, 2),
    openWrapup = _useState10[0],
    setOpenWrapup = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    startConversation = _useState12[0],
    setStartConversation = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    readyToUnassign = _useState14[0],
    setReadyToUnassign = _useState14[1];
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    i18n = _useTranslation.i18n;
  (0, _react.useEffect)(function () {
    i18n.changeLanguage(lang);
  }, [i18n, lang]);
  var selectedConversation = (0, _react.useMemo)(function () {
    return conversations.find(function (c) {
      return c.id === selected.convId && c.campType === selected.campType;
    });
  }, [conversations, selected.convId, selected.campType]);
  (0, _react.useEffect)(function () {
    if (selectedConversation) {
      if (!selectedConversation.chatStarted && selectedConversation.timeoutReached) {
        setStartConversation(true);
      }
      if ((0, _helpers.isNewMedia2)(selectedConversation.type) && selectedConversation && selectedConversation.statusConversation === _constants.USER_STATE.AGENT_READY && endConversations.current.some(function (i) {
        return i.id === selectedConversation.id && i.camptype === selectedConversation.campType;
      })) {
        onDialog();
      }
    }
  }, [selectedConversation]);
  (0, _react.useEffect)(function () {
    if (selectedConversation) {
      if (activeMessage && !selectedConversation.messages.some(function (m) {
        return m.id === activeMessage;
      })) {
        setActiveMessage(undefined);
        setOpenMessages([]);
      }
      if (selectedConversation.type === _constants.TABS.MAIL) {
        selectedConversation.messages.map(function (m) {
          return m.seen = true;
        });
      }
    }
  }, [selectedConversation, activeMessage]);
  var timeoutsByID = (0, _react.useRef)({
    0: {},
    1: {}
  });
  var _useState15 = (0, _react.useState)({
      0: {},
      1: {}
    }),
    _useState16 = _slicedToArray(_useState15, 2),
    warnings = _useState16[0],
    setWarnings = _useState16[1];
  var prevConversations = (0, _hooks.usePrevious)(conversations);
  (0, _react.useEffect)(function () {
    setUnreadCounts(conversations.reduce(function (acc, _ref2) {
      var _objectSpread5;
      var messages = _ref2.messages,
        type = _ref2.type,
        unreadMessage = _ref2.unreadMessage;
      return messages.length === 0 || (0, _helpers.hasUnread)(messages, type, unreadMessage) ? _objectSpread(_objectSpread({}, acc), {}, (_objectSpread5 = {}, _defineProperty(_objectSpread5, _constants.TABS.HOME, acc[_constants.TABS.HOME] + 1), _defineProperty(_objectSpread5, type, acc[type] + 1), _objectSpread5)) : acc;
    }, initialCounts));
    if (!prevConversations || conversations.length !== prevConversations.length) {
      setWarnings(function (w) {
        return conversations.reduce(function (acc, conv) {
          return reduceConversations(acc, conv, w[conv.campType][conv.id] || false);
        }, {
          0: {},
          1: {}
        });
      });
      timeoutsByID.current = conversations.reduce(function (acc, conv) {
        return reduceConversations(acc, conv, [conv.campaign.timeoutWarning, conv.campaign.timeout, conv.type]);
      }, {
        0: {},
        1: {}
      });
    }
  }, [conversations]);
  var onResetAgentTimeout = function onResetAgentTimeout(camptype, id) {
    if (actions.onResetAgentTimeout) actions.onResetAgentTimeout(camptype, id);
  };
  var getDateSetTimeout = function getDateSetTimeout(timer, conv, selected) {
    if (conv.messages == null || conv.messages.length === 0) return null;else if ((0, _helpers.isUnattended)(conv, conv.id === selected.convId && conv.campType === selected.campType) || conv.messages[conv.messages.length - 1].origin !== 'AGENT') {
      // Verifica si la conversacion tiene mensajes sin leer
      if (conv.type === _constants.TABS.MAIL) {
        //Verifica el tipo de media de la conversacion, Caso diferente a Whatsapp
        return conv.initialTime;
      } else {
        // Caso de Whatsapp
        if (timer) {
          //Si ya existe un contador se deja
          return timer;
        } else if (conv.SecTimeOutLastMessageAgent) {
          //Si viene la propiedad de timeout se establece como contador
          onResetAgentTimeout(conv.campType, conv.id);
          return new Date(new Date().getTime() - conv.SecTimeOutLastMessageAgent * 1000);
        } else if (conv.messages[conv.messages.length - 1].origin !== 'AGENT') {
          // Conversacion iniciada
          return new Date();
        }
      }
    }
    return null;
  };
  var _useState17 = (0, _react.useState)({
      0: {},
      1: {}
    }),
    _useState18 = _slicedToArray(_useState17, 2),
    unattendedTimes = _useState18[0],
    setUnattendedTimes = _useState18[1];
  var stoppedUnattendedTimes = (0, _react.useRef)({
    0: {},
    1: {}
  });
  var stoppedTime = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (prevSelected !== null) {
      conversations.forEach(function (m) {
        if (m.id === prevSelected.convId && m.campType === prevSelected.campType && m.type === _constants.TABS.MAIL) {
          m.initialTime = new Date();
        }
      });
    }
    prevSelected.current = selected;
  }, [selected]);
  (0, _react.useEffect)(function () {
    setUnattendedTimes(function (t) {
      return (
        // conversations.reduce((acc, conv) => ({ ...acc, [conv.id]: isUnattended(conv, conv.id === selectedID) ? (t[conv.id] || conv.type === TABS.MAIL ? conv.initialTime : new Date()) : null }), {})
        conversations.reduce(function (acc, conv) {
          return reduceConversations(acc, conv, getDateSetTimeout(t[conv.campType][conv.id], conv, selected));
        }, {
          0: {},
          1: {}
        }
        // [conv.id]: isUnattended(conv, conv.id === selectedID) ? (t[conv.id] || conv.type === TABS.MAIL ? conv.initialTime : isChatStarted(conv) ? new Date() : null) : null
        )
      );
    });
  }, [conversations, selected]);
  (0, _react.useEffect)(function () {
    if (disabledActions) {
      stoppedUnattendedTimes.current = _objectSpread({}, unattendedTimes);
      stoppedTime.current = new Date();
    } else {
      var timesTmp = {};
      var currentDate = new Date();
      for (var camptype in stoppedUnattendedTimes.current) {
        var aux = {};
        for (var key in stoppedUnattendedTimes.current[camptype]) {
          aux[key] = stoppedUnattendedTimes.current[camptype][key] ? new Date(currentDate - (stoppedTime.current - unattendedTimes[camptype][key])) : null;
        }
        timesTmp[camptype] = aux;
      }
      setUnattendedTimes(_objectSpread({}, timesTmp));
      stoppedUnattendedTimes.current = {};
      stoppedTime.current = null;
    }
  }, [disabledActions]);

  /**Effect for setting timeout timers */
  (0, _react.useEffect)(function () {
    var setTimeouts = function setTimeouts(camptype, id, unattendedTime) {
      if (timeoutsByID.current[camptype][id] == null) {
        return [];
      }
      var _timeoutsByID$current = _slicedToArray(timeoutsByID.current[camptype][id], 3),
        timeoutWarning = _timeoutsByID$current[0],
        timeout = _timeoutsByID$current[1],
        type = _timeoutsByID$current[2];
      var timeoutIDs = [];
      if (timeoutWarning > 0) {
        var T = timeoutWarning * 1000 - (0, _dateFns.differenceInMilliseconds)(new Date(), unattendedTime);
        if (T > 0) {
          timeoutIDs.push(setTimeout(function () {
            console.log('warning triggered', id);
            setWarnings(function (w) {
              return _objectSpread(_objectSpread({}, w), {}, _defineProperty({}, camptype, _objectSpread(_objectSpread({}, w[camptype]), {}, _defineProperty({}, id, true))));
            });
          }, T));
        } else {
          setWarnings(function (w) {
            return _objectSpread(_objectSpread({}, w), {}, _defineProperty({}, camptype, _objectSpread(_objectSpread({}, w[camptype]), {}, _defineProperty({}, id, true))));
          });
        }
      }
      if (timeout > 0) {
        var T2 = timeout * 1000 - (0, _dateFns.differenceInMilliseconds)(new Date(), unattendedTime);
        if (T2 > 0) {
          timeoutIDs.push(setTimeout(function () {
            console.log('timeout triggered', camptype, id);
            if (type === _constants.TABS.MAIL) {
              unassignRef.current(camptype, id);
            }
            if ((0, _helpers.isNewMedia)(type)) {
              endConversations.current.push({
                camptype: camptype,
                id: id,
                isReassigned: _constants.REASSIGNED_TYPES.BY_TIMEOUT
              });
              setReadyToUnassign(true);
            } else {
              finishRef.current(camptype, id);
            }
          }, T2));
        } else {
          if (type === _constants.TABS.MAIL) {
            unassignRef.current(camptype, id);
          } else if (!(0, _helpers.isNewMedia)(type)) {
            finishRef.current(camptype, id);
          }
        }
      }
      return timeoutIDs;
    };
    var timeouts = Object.entries(unattendedTimes).reduce(function (out, _ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        camptype = _ref4[0],
        convs = _ref4[1];
      var arr = Object.entries(convs).reduce(function (acc, _ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          id = _ref6[0],
          time = _ref6[1];
        if (time === null || disabledActions) return acc;
        return [].concat(_toConsumableArray(acc), _toConsumableArray(setTimeouts(parseInt(camptype, 10), parseInt(id, 10), time)));
      }, []);
      return [].concat(_toConsumableArray(out), _toConsumableArray(arr));
    }, []);
    return function () {
      return timeouts.map(function (t) {
        return clearTimeout(t);
      });
    };
  }, [unattendedTimes]);

  /* const warnedTabs = useMemo(
  	() =>
  		Object.entries(warnings).reduce((acc, [key, val]) => {
  			if (!val) return acc;
  			const conv = conversations.find(c => c.id === parseInt(key, 10));
  			if (!conv) return acc;
  			acc.push(conv.type);
  			return acc;
  		}, []),
  	[warnings, conversations]
  ); */

  var isOnDialog = function isOnDialog(statusConv) {
    return statusConv === _constants.USER_STATE.DIALOG || statusConv === _constants.USER_STATE.DIALOG_EMAIL || statusConv === _constants.USER_STATE.DIALOG_WHATSAPP;
  };
  var onSelectConversation = function onSelectConversation(camptype, id) {
    if (id !== undefined) {
      setWarnings(function (w) {
        return _objectSpread(_objectSpread({}, w), {}, _defineProperty({}, camptype, _objectSpread(_objectSpread({}, w[camptype]), {}, _defineProperty({}, id, false))));
      });
      if (selectedConversation && selectedConversation.id !== id && selectedConversation.campType !== camptype && isOnDialog(selectedConversation.statusConversation)) {
        console.log('onReady', selectedConversation.campType, selectedConversation.id);
        if (actions.onReady) actions.onReady(selectedConversation.campType, selectedConversation.id);
      }
      setTimeout(function () {
        onSelect(camptype, id);
      }, 100);
    }
  };
  var onActiveMessage = function onActiveMessage(msgId) {
    setActiveMessage(msgId);
    setOpenMessages([msgId]);
  };
  var toggleOpenMessage = function toggleOpenMessage(msgId) {
    if (openMessages.length === 0) setActiveMessage(msgId);
    setOpenMessages(function (o) {
      return o.includes(msgId) ? o.filter(function (id) {
        return id !== msgId;
      }) : [].concat(_toConsumableArray(o), [msgId]);
    });
  };
  var onActiveTab = function onActiveTab(tab) {
    if (tab !== _constants.TABS.HOME && (!selectedConversation || selectedConversation.type !== tab)) {
      var filtrd = conversations.filter(function (conv) {
        return conv.type === tab;
      });
      if (filtrd.length > 0) onSelectConversation(filtrd[0].campType, filtrd[0].id);
    }
    setActiveTab(tab);
  };
  var onFinish = function onFinish(camptype, id, isReassigned) {
    console.log("onFinish(".concat(camptype, ", ").concat(id, ")"));
    if (actions.onFinish) actions.onFinish(camptype, id, isReassigned);
  };
  var finishRef = (0, _react.useRef)(onFinish);
  (0, _react.useEffect)(function () {
    finishRef.current = onFinish;
  });
  var onAceptedChat = function onAceptedChat(camptype, id) {
    console.log('onAceptedChat', camptype, id);
    if (actions.onAceptedChat) actions.onAceptedChat(camptype, id);
    if (actions.onDialog) actions.onDialog(camptype, id);
    if (actions.onAcceptChatSaveTime) actions.onAcceptChatSaveTime(camptype, id);
  };
  var AceptedChatRef = (0, _react.useRef)(onAceptedChat);
  (0, _react.useEffect)(function () {
    AceptedChatRef.current = onAceptedChat;
  });
  var getMessageId = function getMessageId(conversation) {
    return conversation.id === selected.convId && conversation.campType === selected.campType && activeMessage || (conversation.messages && conversation.messages.length > 0 ? conversation.messages[0].id : undefined);
  };
  var onUnassign = function onUnassign(camptype, id) {
    if (actions.onUnassign) {
      var messageId = getMessageId(conversations.find(function (c) {
        return c.id === id && c.campType === camptype;
      }));
      console.log("onUnassign(camptype: ".concat(camptype, ", id: ").concat(id, ", message: ").concat(messageId, ")"));
      actions.onUnassign(camptype, id, messageId);
    }
  };
  var unassignRef = (0, _react.useRef)(onUnassign);
  (0, _react.useEffect)(function () {
    unassignRef.current = onUnassign;
  });
  var onSpam = function onSpam(camptype, id) {
    if (actions.onSpam) {
      var messageId = getMessageId(conversations.find(function (c) {
        return c.id === id && c.campType === camptype;
      }));
      console.log("onSpam(camptype: ".concat(camptype, ", id: ").concat(id, ", message ").concat(messageId, ")"));
      actions.onSpam(camptype, id, messageId);
    }
  };
  var onDiscard = function onDiscard(camptype, id) {
    if (actions.onDiscard) {
      var messageId = getMessageId(conversations.find(function (c) {
        return c.id === id && c.campType === camptype;
      }));
      console.log("onDiscard(camptype: ".concat(camptype, ", id:").concat(id, ", message:").concat(messageId, ")"));
      actions.onDiscard(camptype, id, messageId);
    }
  };
  var onWrapUp = function onWrapUp(camptype, id, disposition) {
    console.log("onWrapUp(camptype: ".concat(camptype, ", id:").concat(id, ", disposition:").concat(disposition, ")"));
    if (actions.onWrapUp) {
      actions.onWrapUp(camptype, id, disposition);
      setOpenWrapup(false);
    }
  };
  var onSendResponse = function onSendResponse(camptype, id, message, messageId, subject, attachments, from, to, cc, bcc, IsAzure, fileType) {
    console.log("onSendResponse(camptype: ".concat(camptype, ", id:").concat(id, ", message:").concat(message, ")"));
    if (actions.onSendResponse) {
      var addresses = from && to ? {
        From: from,
        To: [to],
        CC: cc,
        BCC: bcc
      } : undefined;
      actions.onSendResponse({
        camptype: camptype,
        id: id,
        messageId: messageId,
        subject: subject,
        message: message,
        addresses: addresses,
        attachments: attachments,
        IsAzure: IsAzure,
        fileType: fileType
      });
    }
  };
  var onAttachments = function onAttachments(camptype, id) {
    console.log("onAttachements(camptype: ".concat(camptype, ", id:").concat(id, ")"));
    actions.onAttachments(camptype, id);
  };
  var onUploadAttachments = function onUploadAttachments(camptype, id, fileName, file) {
    console.log("onUploadAttachments(".concat(camptype, ", ").concat(id, ", ").concat(fileName, ", ").concat(file, ")"));
    actions.onUploadAttachments(camptype, id, fileName, file);
  };
  var onDeleteAttachment = function onDeleteAttachment(camptype, id, fileName) {
    console.log("onDeleteAttachment(".concat(camptype, " ").concat(id, ", ").concat(fileName, ")"));
    actions.onDeleteAttachment(camptype, id, fileName);
  };
  var onDialog = function onDialog() {
    var dispatchDialog = false;
    switch (selectedConversation.type) {
      case _constants.TABS.WHATSAPP:
        if (selectedConversation.statusConversation !== _constants.USER_STATE.DIALOG_WHATSAPP && selectedConversation.chatStarted) {
          dispatchDialog = true;
        }
        break;
      case _constants.TABS.MAIL:
        if (selectedConversation.statusConversation !== _constants.USER_STATE.DIALOG_EMAIL) {
          dispatchDialog = true;
        }
        break;
      case _constants.TABS.CHAT:
        dispatchDialog = true;
        break;
      default:
        break;
    }
    if (dispatchDialog) {
      console.log("onDialog(".concat(selectedConversation.campType, ", ").concat(selectedConversation.id, ")"));
      if (actions.onDialog) actions.onDialog(selectedConversation.campType, selectedConversation.id);
    }
  };
  (0, _react.useEffect)(function () {
    /* if (selectedConversation.statusConversation === USER_STATE.AGENT_READY && endConversations.current.some(i => i.id === selectedConversation.id && i.camptype === selectedConversation.campType)) {
    	onDialog();
    } */
    if (selectedConversation && endConversations.current.some(function (c) {
      return c.id === selectedConversation.id && c.camptype === selectedConversation.campType;
    })) {
      var conv = endConversations.current.find(function (c) {
        return c.id === selectedConversation.id && c.camptype === selectedConversation.campType;
      });
      finishRef.current(selectedConversation.campType, selectedConversation.id, conv.isReassigned);
      if (!conv.isReassigned && selectedConversation.campaign.showWrapUp) {
        setOpenWrapup(true);
      }
      if (readyToUnassign) {
        setReadyToUnassign(false);
      }
      var i = endConversations.current.findIndex(function (c) {
        return c.id === selectedConversation.id && c.camptype === selectedConversation.campType;
      });
      endConversations.current.splice(i, 1);
    }
  }, [selectedConversation, readyToUnassign]);
  var onLoadMessages = function onLoadMessages(camptype, id) {
    if (actions.onLoadMessages) {
      console.log("onLoadMessages(camptype: ".concat(camptype, ", id:").concat(id, ")"));
      actions.onLoadMessages(camptype, id);
    }
  };
  var onUpdateDraftMessage = function onUpdateDraftMessage(msgId, data) {
    if (actions.onUpdateDraftMessage) {
      console.log("onUpdateDraftMessage(id:".concat(msgId, ")"));
      actions.onUpdateDraftMessage(msgId, data);
    }
  };
  var onDeleteDraftMessage = function onDeleteDraftMessage(msgId) {
    if (actions.onDeleteDraftMessage) {
      console.log("onDeleteDraftMessage(id:".concat(msgId, ")"));
      actions.onDeleteDraftMessage(msgId);
    }
  };
  var onUpdateDraftAttachments = function onUpdateDraftAttachments(msgId, data) {
    if (actions.onUpdateDraftAttachments) {
      console.log("onUpdateDraftAttachments(id:".concat(msgId, ")"));
      actions.onUpdateDraftAttachments(msgId, data);
    }
  };
  var getRequestFunc = function getRequestFunc(type) {
    switch (type) {
      case 'unassign':
        if (selectedConversation && (selectedConversation.type === 'WHATSAPP' && selectedConversation.allowUnassign && !selectedConversation.disabledUnassign || selectedConversation.type !== 'WHATSAPP')) {
          return onUnassign;
        }
        return undefined;
      case 'spam':
        if (selectedConversation && (selectedConversation.type === 'WHATSAPP' && selectedConversation.allowSpam || selectedConversation.type !== 'WHATSAPP')) {
          return onSpam;
        }
        return undefined;
      default:
        return undefined;
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-um-tabs"
  }, /*#__PURE__*/_react["default"].createElement(_NewTabBar["default"], {
    tabs: tabs,
    unreadCounts: unreadCounts,
    activeTab: activeTab,
    setActiveTab: onActiveTab
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-wrapper-conversation"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uim-conversation"
  }, /*#__PURE__*/_react["default"].createElement(_ConversationList["default"], {
    showType: activeTab,
    conversations: conversations,
    unattendedTimes: unattendedTimes,
    warnings: warnings,
    selected: selected,
    onSelect: onSelectConversation,
    activeMessageId: activeMessage,
    onSelectMessage: onActiveMessage,
    disabledActions: disabledActions
  })), /*#__PURE__*/_react["default"].createElement(_ConversationView["default"], {
    lang: lang,
    agent: agent,
    conversation: selectedConversation,
    draftMessages: draftMessages,
    openMessages: openMessages,
    toggle: toggleOpenMessage,
    openWrapup: openWrapup,
    setTheUrlOfAttachments: setTheUrlOfAttachments,
    startConversation: startConversation,
    disabledActions: disabledActions,
    setStartConversation: setStartConversation,
    setNumFiles: setNumFiles,
    onUnassign: getRequestFunc('unassign'),
    onSpam: getRequestFunc('spam'),
    onUpdateDraftMessage: onUpdateDraftMessage,
    onUpdateDraftAttachments: onUpdateDraftAttachments,
    onDeleteDraftMessage: onDeleteDraftMessage,
    getUploadState: getUploadState,
    onShowAlertDisconexion: actions.onShowAlertDisconexion,
    onFinish: onFinish,
    onDiscard: onDiscard,
    onWrapUp: onWrapUp,
    onSendResponse: onSendResponse,
    onAttachments: onAttachments,
    onUploadAttachments: onUploadAttachments,
    onDeleteAttachment: onDeleteAttachment,
    onAceptedChat: onAceptedChat,
    onDialog: onDialog,
    onLoadMessages: onLoadMessages
  })));
};
UnifiedInbox.propTypes = {
  conversations: _propTypes["default"].arrayOf(_types.conversationType).isRequired,
  selectedID: _propTypes["default"].number,
  onSelect: _propTypes["default"].func,
  onFinish: _propTypes["default"].func,
  onUnassign: _propTypes["default"].func,
  onSpam: _propTypes["default"].func,
  onDiscard: _propTypes["default"].func,
  onWrapUp: _propTypes["default"].func,
  onSendResponse: _propTypes["default"].func,
  lang: _propTypes["default"].string,
  onAceptedChat: _propTypes["default"].func,
  onReady: _propTypes["default"].func,
  onDialog: _propTypes["default"].func,
  onResetAgentTimeout: _propTypes["default"].func,
  onAcceptChatSaveTime: _propTypes["default"].func
};
UnifiedInbox.defaultProps = {
  conversations: [],
  selected: {},
  lang: 'es'
};
var _default = exports["default"] = UnifiedInbox;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/UnifiedInbox.js
// module id = 1428
// module chunks = 0